<div class="remove-button">
  <span class="close-icon" (click)="cancel()">X</span>
</div>
<div>
  <label><strong>{{ notification.title }}</strong></label>
</div>
<div class="notification-date-time">
  <label><i class="fas fa-clock"></i>  {{ notification.createdDate | localizedDate }}</label>
</div>
<div>  
  <div [innerHTML]="notification.message"></div>
</div>